export function CopyAllIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M12.3333 1.33325H6.33325C5.59992 1.33325 4.99992 1.93325 4.99992 2.66659V10.6666C4.99992 11.3999 5.59992 11.9999 6.33325 11.9999H12.3333C13.0666 11.9999 13.6666 11.3999 13.6666 10.6666V2.66659C13.6666 1.93325 13.0666 1.33325 12.3333 1.33325ZM12.3333 10.6666H6.33325V2.66659H12.3333V10.6666ZM2.33325 9.99992V8.66658H3.66659V9.99992H2.33325ZM2.33325 6.33325H3.66659V7.66658H2.33325V6.33325ZM6.99992 13.3333H8.33325V14.6666H6.99992V13.3333ZM2.33325 12.3333V10.9999H3.66659V12.3333H2.33325ZM3.66659 14.6666C2.93325 14.6666 2.33325 14.0666 2.33325 13.3333H3.66659V14.6666ZM5.99992 14.6666H4.66659V13.3333H5.99992V14.6666ZM9.33325 14.6666V13.3333H10.6666C10.6666 14.0666 10.0666 14.6666 9.33325 14.6666ZM3.66659 3.99992V5.33325H2.33325C2.33325 4.59992 2.93325 3.99992 3.66659 3.99992Z"
        fill="#2E2E2F"
      />
    </svg>
  )
}
